import { extractNumbers } from "./extractNumbers";
import { CUSTOMER_SUPPLIER_CONFLICT, ICustomerSupplierConflict } from "../interfaces/customersSuppliers";

/** Conflito de documento devolvido pelo backend (409), se o erro for esse. */
export function getCustomerSupplierConflict(error: unknown): ICustomerSupplierConflict | undefined {
  const data = (error as { response?: { data?: { code?: string; conflict?: ICustomerSupplierConflict } } })?.response?.data;
  return data?.code === CUSTOMER_SUPPLIER_CONFLICT ? data.conflict : undefined;
}

/** Copia para o cadastro os campos preenchidos do cadastro que já usa o documento. */
export function copyCustomerSupplierConflictData<T extends object>(record: T, conflict: ICustomerSupplierConflict): T {
  const filled = Object.entries(conflict.data).filter(([, value]) => value);
  return { ...record, ...Object.fromEntries(filled) };
}

/** Campos da terceirizada e do cliente que o backend propaga para o cliente/fornecedor; o cliente não tem telefone. */
export interface ICustomerSupplierSyncedFields {
  name?: string;
  email?: string;
  address?: string;
  document?: string;
  phone?: string;
}

const normalize = ({ name, email, address, document, phone }: ICustomerSupplierSyncedFields) => ({
  name: name || "",
  email: email || "",
  address: address || "",
  document: extractNumbers(document || ""),
  phone: phone || "",
});

/** Indica se algum campo propagado ao cliente/fornecedor mudou; o documento é comparado só pelos dígitos. */
export function hasCustomerSupplierChanges(
  before: ICustomerSupplierSyncedFields,
  after: ICustomerSupplierSyncedFields,
): boolean {
  const previous = normalize(before);
  const next = normalize(after);
  return (Object.keys(previous) as (keyof typeof previous)[]).some((field) => previous[field] !== next[field]);
}
